export enum SceneDefinitionLayerType {
    POINTCLOUD = "POINTCLOUD",
    PHOTOSPHERE = "PHOTOSPHERE",
    // TODO
    PRIMITIVE = "PRIMITIVE",
    SPRITE = "SPRITE",
    LABEL = "LABEL",
    CUSTOM = "CUSTOM",
}
